import { FeatureDefinition } from '../entities';

export const openedReadingExperiment = 'appnebula_web2app_content_test_opened_reading';

export enum OpenedReadingExperimentGroups {
  CONTROL = 'control',
  TEST = 'test',
}

export const openedReadingExperimentConfig: FeatureDefinition = {
  defaultValue: OpenedReadingExperimentGroups.CONTROL,
};
